import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { UsageFeatureProps } from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { useDynamicReducer } from '@micro-frontend-react/employee-experience/lib/useDynamicReducer';
import { useContext, useEffect } from 'react';
import { Reducer } from 'redux';
import { IEvlAppState } from '../../App.types';
import { ILetterGenerationPdf } from '../../models/ILetterGenerationPdf';
import { ILetterMetadata } from '../../models/ILetterMetadata';
import { ILetterTemplate } from '../../models/ILetterTemplate';
import { IUserProfile } from '../../models/IUserProfile';
import { requestMetadata } from '../actions/metadataActions';
import { letterMetadataInitialState, letterMetadataReducer } from '../reducers/metadataReducer';
import { letterMetadataSagas } from '../sagas/metadataSagas';

export function useLetterMetadata(
  feature: UsageFeatureProps,
  selectedTemplate: ILetterTemplate
): [
  ILetterMetadata,
  ILetterGenerationPdf | null,
  boolean,
  boolean,
  string | null,
  boolean,
  boolean,
  boolean,
  boolean,
  string | null,
  string | null,
  string | null
] {
  useDynamicReducer(
    'metadata_reducer',
    letterMetadataReducer as Reducer,
    [letterMetadataSagas],
    false
  );

  const { dispatch, useSelector } = useContext(
    Context as React.Context<IEmployeeExperienceContext>
  );

  const {
    letterMetadata,
    letterPdf,
    hasError,
    isLoading,
    errorMessage,
    isLoadingLetterGeneration,
    isLoadingLetterSubmission,
    hasErrorLetterGeneration,
    hasErrorLetterSubmission,
    errorMessageLetterGeneration,
    errorMessageLetterSubmission,
    crmActivityId,
  } = useSelector(
    (state: IEvlAppState) => state?.dynamic?.['metadata_reducer'] ?? letterMetadataInitialState
  );

  return [
    letterMetadata,
    letterPdf,
    hasError,
    isLoading,
    errorMessage,
    isLoadingLetterGeneration,
    isLoadingLetterSubmission,
    hasErrorLetterGeneration,
    hasErrorLetterSubmission,
    errorMessageLetterGeneration,
    errorMessageLetterSubmission,
    crmActivityId,
  ];
}
